<div class="d-flex flex-row align-content-center mg-t-5 mg-b-5">
  <div class="mg-r-30 align-self-center">
    <label class="mg-r-5">Recherche denrée : </label>
    <input type="text" [(ngModel)]="produitDeclinaisonSearch"
           (ngModelChange)='changedSearchProduitDeclinaisonLibelle($event)'
           placeholder="Déclinaison(s)..."
           class="input-search-denree">
  </div>
  <div class="mg-r-30 align-self-center">
    <label class="mg-r-5">Recherche article : </label>
    <input type="text" [(ngModel)]="articleSearch"
           (ngModelChange)='changedSearchArticleLibelle($event)'
           class="input-search-denree"
           placeholder="Article(s)...">
  </div>
  <div class="mg-r-5 align-self-center" style="display:ruby;">
    <label class="mg-r-5">Fournisseurs : </label>
    <dx-tag-box
      [style]="{minWidth:'300px'}"
      searchEnabled="true"
      searchExpr="libelle"
      [showSelectionControls]="true"
      applyValueMode="instantly"
      [maxDisplayedTags]="3"
      [multiline]="false"
      [showMultiTagOnly]="false"
      placeholder="Sélection, recherche..."
      searchMode="contains"
      [dataSource]="fournisseurList"
      displayExpr="libelle"
      valueExpr="id"
      (onValueChanged)="changeFournisseurSelection($event)"
    ></dx-tag-box>
  </div>
</div>
<dx-data-grid
  [dataSource]="customStore"
  [remoteOperations]="true"
  keyExpr="id"
  height="75vh"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  #grid>

  <dxi-column dataField="produitDeclinaisonLibelle" caption="Déclinaison"
              [allowFiltering]="false"
              sortOrder="asc"
              cellTemplate="declinaisonCellTemplate">
  </dxi-column>
  <dxi-column dataField="produitDeclinaisonCode" caption="Code denrée"
              [allowFiltering]="false"
              [width]="150">
  </dxi-column>
  <dxi-column dataField="produitArticleLibelle" caption="Article"
              cellTemplate="articleCellTemplate">
  </dxi-column>
  <dxi-column dataField="fournisseur"
              caption="Fournisseur"
              cellTemplate="fournisseurCellTemplate"
              [width]="200">
  </dxi-column>
  <dxi-column dataField="produitArticle.reference" caption="Ref article"
              [width]="200">
  </dxi-column>
  <dxi-column dataField="groupeAchatCaList"
              cellTemplate="groupeAchatCaCellTemplate"
              caption="Prix d'achat en UF"
              [width]="150">
  </dxi-column>
  <dxi-column dataField="prix" alignment="left"
              name="prixkg"
              cellTemplate="prixKgCellTemplate"
              caption="Prix au Kg"
              [width]="150">
  </dxi-column>

  <!-- PRODUIT DELINAISON GROUPING TEMPLATE -->
  <div *dxTemplate="let cell of 'declinaisonCellTemplate'">

    <div class="d-flex flex-row align-items-center">

      <label [style.fontWeight]="'bold'" [style.color]="colorsDenrees[cell.row.data.produitDeclinaisonCode]"
             [title]="cell.row.data?.produitDeclinaisonLibelle"
             class="font-12 custom-letter-grey mg-b-0 align-self-center">
        <i *ngIf="!cell.row.data.produitDeclinaisonActif" title="Attention, denrée inactive !"
           class="fas fa-exclamation-triangle danger-color cursor"></i>
        <i class="fas fa-apple-alt " [title]="isManuelFavoriteAppleColor(cell) ? 'Préféré activé manuellement' : ''"
           [ngClass]="isManuelFavoriteAppleColor(cell) ? 'modification-mamuelle':'custom-letter-grey' "></i>
        {{ cell.row.data?.produitDeclinaisonLibelle | uppercase}}
      </label>
      <div style="margin-left: 15px;">
        <yo-info-lotmarche-article [uniteDeProductionId]="uniteDeProduction.id"
                                   [lotMarchePdLumpCa]="cell.row.data?.lmPdUpCa"></yo-info-lotmarche-article>
      </div>
    </div>
  </div>

  <!-- ARTICLE -->
  <div *dxTemplate="let cell of 'articleCellTemplate'">
    <div class="no-overflow">
      <label class="font-12" title="{{cell.data.produitArticle.libelle}}">
        {{cell.data.produitArticle.libelle | uppercase}}
      </label>
    </div>
  </div>

  <!-- FOURNISSEUR -->
  <div class="d-flex justify-content-between" *dxTemplate="let cell of 'fournisseurCellTemplate'">
    <label class="font-12">
      {{cell.data.fournisseur.libelle | uppercase}}
    </label>
    <div class="size-icon" *ngIf="!utils.isNullOrEmpty(cell.data.fournisseurOwnerLibelle)"
         [title]="'Hérité du founisseur : ' +cell.data.fournisseurOwnerLibelle">
      <span class="fa-stack fa-2x">
        <i class="fas fa-circle fa-stack-2x"></i>
        <strong class="fa-stack-1x custom-letter">H</strong>
      </span>
    </div>
  </div>

  <!-- PRIX ACHAT CELL TEMPLATE-->
  <div *dxTemplate="let cell of 'groupeAchatCaCellTemplate'">
    <div *ngFor="let groupeAchatCa of cell.data?.groupeAchatCaList" class="d-flex flex-column">
      <div class="d-flex flex-row align-items-center">
        <ng-container [ngSwitch]="groupeAchatCa.prefere">
          <i *ngSwitchCase="true" class="mg-r-5 fas fa-star cursor"
             [ngClass]="groupeAchatCa.modificationManuelle ? 'modification-mamuelle': ''"
             [title]="groupeAchatCa.modificationManuelle ?'Article préféré activé par modification manuelle ('+groupeAchatCa.creerPar +')':'Article préféré'"></i>
          <i *ngSwitchCase="false" class="mg-r-5 far fa-star cursor rotate-1-turn"
             title="Rendre l'article comme préféré"
             (click)="updatePrefere(cell.data, groupeAchatCa)"></i>
          <ng-container *ngSwitchCase="undefined">
            <!--                // DO NOTHING-->
          </ng-container>
        </ng-container>
        <div>{{groupeAchatCa.prixUF.value | currency:'EUR':'symbol':'1.4-4'}}
          / {{cell.data.uniteDeFacturation.abreviation | slice:0:5}}
          <span
            [title]="'Prix préférentiel lié au groupe : '+groupeAchatCa.libelleGroupeAchat">{{cell.data.groupeAchatCaList.length > 1 ? '(' + groupeAchatCa.libelleGroupeAchat + ')' : ''}}</span>
        </div>
      </div>
    </div>
  </div>

  <div *dxTemplate="let cell of 'prixKgCellTemplate'">
    <div *ngFor="let groupeAchatCa of cell.data?.groupeAchatCaList" class="d-flex flex-column">
      <div class="d-flex flex-row align-items-center">
        <div>{{groupeAchatCa.prixKg.value | currency:'EUR':'symbol':'1.4-4'}}
          <span
            [title]="'Prix préférentiel lié au groupe : '+groupeAchatCa.libelleGroupeAchat">{{cell.data.groupeAchatCaList.length > 1 ? '(' + groupeAchatCa.libelleGroupeAchat + ')' : ''}}</span>
        </div>
      </div>
    </div>
  </div>

  <dxo-paging [pageSize]="50"></dxo-paging>
  <dxo-pager
    [showPageSizeSelector]="true"
    [showNavigationButtons]="true"
    [allowedPageSizes]="[20, 50, 100, 200]"
    [visible]="true"
    [showInfo]="true"
    infoText="{2} article(s) préféré(s)">
  </dxo-pager>

</dx-data-grid>


